export const getConditionTextPrefix = (conditionListIndex: number) => {
  const isFirstCondition = conditionListIndex === 0;
  return isFirstCondition ? 'Where' : 'And';
};
